import { render, staticRenderFns } from "./PricingPublicLiabilityPrimaryLayer.vue?vue&type=template&id=9da304ae"
import script from "./PricingPublicLiabilityPrimaryLayer.vue?vue&type=script&lang=js"
export * from "./PricingPublicLiabilityPrimaryLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports